import { api } from './api'
import { throwApiError } from './apiHelpers'

function assertSuccess(body: { success?: boolean; message?: string; data?: unknown }) {
  if (!body?.success) {
    const err = new Error(body?.message || 'Request failed') as Error & { code?: string }
    err.code = (body as { error?: { code?: string } }).error?.code
    throw err
  }
  return body.data
}

export type StoreMemberAdminRow = {
  id: number
  accountId: number
  email: string
  firstName: string
  lastName: string
  role: 'store_owner' | 'staff'
  modules: string[] | null
  status: string
  mustChangePassword: boolean
}

/** super_admin — store_memberships for platform ops */
export async function listStoreMembers(storeId: number | string): Promise<{ items: StoreMemberAdminRow[] }> {
  try {
    const { data } = await api.get(`/admin/stores/${encodeURIComponent(String(storeId))}/members`)
    return assertSuccess(data) as { items: StoreMemberAdminRow[] }
  } catch (e) {
    throwApiError(e, 'Failed to load store members')
  }
}

export async function resetStoreMemberCredentials(
  storeId: number | string,
  membershipId: number | string,
): Promise<{ emailSent?: boolean }> {
  try {
    const { data } = await api.post(
      `/admin/stores/${encodeURIComponent(String(storeId))}/members/${encodeURIComponent(String(membershipId))}/reset-credentials`,
    )
    return assertSuccess(data) as { emailSent?: boolean }
  } catch (e) {
    throwApiError(e, 'Failed to reset member credentials')
  }
}
